import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerExportOptions } from '../models/partner-export-options';
import { CurrentUserService } from '../../user/services';
import { ConfigurationService } from '../../configuration/services/configuration.service';
import { FormsModule } from '@angular/forms';

@Component({
    templateUrl: './partner-export-modal.component.html',
    styleUrls: ['./partner-export-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class PartnerExportModalComponent {

  public exportOptions: PartnerExportOptions = {
    exportContacts: true,
    exportConfigurationKeys: true,
    exportTags: true,
    exportProxyRelations: true,
    exportX12EdifactConfig: true,
    exportTransportOutConfig: true
  };

  defaultIncludeArtifacts: boolean = true;
  hasIncludeArtifactsAdminPermission: boolean = true;
  hasExportArtifactsPermission: boolean = false;

  constructor(private activeModal: NgbActiveModal) {
  }

  ok() {
    this.activeModal.close(this.exportOptions);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
